/*
  Pestañas de colección de la home (sections/home-collection-tabs.liquid).
  Aislado por completo: solo actúa dentro de [data-mm-panels]; si la página no tiene
  esa sección, este script no hace nada y no registra ningún listener con efecto.
*/
(function () {
  if (window.__mmHomeTabsBound) return;
  window.__mmHomeTabsBound = true;

  function gtagEvento(nombre, datos) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nombre, datos || {});
      }
    } catch (e) {
      /* no-op: nunca debe romper la navegación por un fallo de analítica */
    }
  }

  function extraerFragmento(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var envoltorio = doc.querySelector('[id^="shopify-section-"]');
    return envoltorio ? envoltorio.innerHTML : doc.body.innerHTML;
  }

  /*
    Los navegadores NUNCA ejecutan un <script> insertado vía innerHTML (aquí,
    panel.innerHTML = ...). Eso es justo lo que rompía los círculos de color:
    el script de snippets/mundomantel-colores-card.liquid nunca llegaba a
    correr para las cards de esta pestaña, así que sus listeners delegados no
    se registraban nunca. La solución estándar es recrear a mano cada
    <script> que SÍ necesita ejecutarse — nunca TODOS los <script> del
    fragmento (incluye cosas como quick-add.js que no deben recargarse, y que
    además fallarían al redefinir sus custom elements) — por eso se filtra
    estrictamente por [data-mm-reexec].
  */
  function reejecutarScripts(contenedor) {
    contenedor.querySelectorAll('script[data-mm-reexec]').forEach(function (viejo) {
      var nuevo = document.createElement('script');
      for (var i = 0; i < viejo.attributes.length; i++) {
        var attr = viejo.attributes[i];
        nuevo.setAttribute(attr.name, attr.value);
      }
      nuevo.textContent = viejo.textContent;
      viejo.replaceWith(nuevo);
    });
  }

  function cargarPanel(panel) {
    if (!panel || panel.dataset.mmLoaded === '1' || panel.dataset.mmLoading === '1') return;
    panel.dataset.mmLoading = '1';
    var handle = panel.dataset.collectionHandle;
    var sectionId = panel.dataset.sectionId;
    if (!handle || !sectionId) return;

    var url = '/collections/' + handle + '?section_id=' + sectionId + '&sort_by=best-selling';
    fetch(url)
      .then(function (resp) {
        if (!resp.ok) throw new Error('mm-home-tabs: respuesta no OK al cargar la pestaña');
        return resp.text();
      })
      .then(function (html) {
        panel.innerHTML = extraerFragmento(html);
        reejecutarScripts(panel);
        panel.dataset.mmLoaded = '1';
        delete panel.dataset.mmLoading;
      })
      .catch(function () {
        delete panel.dataset.mmLoading;
        var skeleton = panel.querySelector('[data-mm-skeleton]');
        if (skeleton) {
          var aviso = document.createElement('p');
          aviso.className = 'mm-home-tabs__error';
          aviso.textContent = 'No se pudieron cargar los productos. Inténtalo de nuevo.';
          panel.appendChild(aviso);
        }
      });
  }

  function resetearCarrusel(panel) {
    var track = panel.querySelector('[id^="Slider-mm-home-"]');
    if (track) track.scrollTo({ left: 0, behavior: 'auto' });
  }

  function initGrupo(panelsWrap) {
    var sectionId = panelsWrap.dataset.sectionId;
    var header = panelsWrap.closest('.mm-home-tabs');
    if (!header) return;
    var tabs = Array.prototype.slice.call(header.querySelectorAll('[data-mm-tab]'));
    var panels = Array.prototype.slice.call(panelsWrap.querySelectorAll('[data-mm-panel]'));
    if (!tabs.length || !panels.length) return;

    function panelDe(indice) {
      return panels.filter(function (p) {
        return p.dataset.tabIndex === String(indice);
      })[0];
    }

    function tabNameDe(indice) {
      var tab = tabs[indice];
      var texto = tab ? tab.textContent.trim().toLowerCase() : '';
      if (texto.indexOf('individual') > -1) return 'individuales';
      if (texto.indexOf('medida') > -1) return 'a_medida';
      return 'tab_' + indice;
    }

    function activar(indice, opts) {
      opts = opts || {};
      var tabActivo = tabs[indice];
      var panelActivo = panelDe(indice);
      if (!tabActivo || !panelActivo) return;

      cargarPanel(panelActivo);

      var panelesVisibles = panels.filter(function (p) {
        return !p.hasAttribute('hidden');
      });
      var alturaPrevia = panelesVisibles.length ? panelesVisibles[0].getBoundingClientRect().height : 0;
      if (alturaPrevia) panelsWrap.style.minHeight = alturaPrevia + 'px';

      tabs.forEach(function (t, i) {
        var esta = i === indice;
        t.classList.toggle('mm-home-tabs__tab--active', esta);
        t.setAttribute('aria-selected', esta ? 'true' : 'false');
        t.setAttribute('tabindex', esta ? '0' : '-1');
      });

      panels.forEach(function (p) {
        if (p === panelActivo) {
          p.hidden = false;
          p.classList.remove('mm-home-tabs__panel--fading');
        } else if (!p.hidden) {
          p.classList.add('mm-home-tabs__panel--fading');
          setTimeout(function () {
            p.hidden = true;
            p.classList.remove('mm-home-tabs__panel--fading');
          }, 190);
        }
      });

      resetearCarrusel(panelActivo);

      window.requestAnimationFrame(function () {
        setTimeout(function () {
          panelsWrap.style.minHeight = '';
        }, 220);
      });

      if (opts.foco) tabActivo.focus();
      if (opts.disparaGA4) gtagEvento('home_tab_click', { tab_name: tabNameDe(indice) });
    }

    tabs.forEach(function (tab, indice) {
      tab.addEventListener('click', function () {
        activar(indice, { disparaGA4: true });
      });

      // Precarga en hover en desktop, sin activar la pestaña
      tab.addEventListener('mouseenter', function () {
        var panel = panelDe(indice);
        if (panel) cargarPanel(panel);
      });

      tab.addEventListener('keydown', function (evt) {
        var idx = tabs.indexOf(evt.currentTarget);
        var next = null;
        if (evt.key === 'ArrowRight') next = (idx + 1) % tabs.length;
        else if (evt.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
        else if (evt.key === 'Home') next = 0;
        else if (evt.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          evt.preventDefault();
          activar(next, { foco: true, disparaGA4: true });
        }
      });
    });

    panelsWrap.addEventListener('click', function (evt) {
      var link = evt.target.closest ? evt.target.closest('[data-mm-view-all]') : null;
      if (!link) return;
      var indice = parseInt(link.dataset.tabIndex, 10);
      gtagEvento('home_view_all_click', {
        tab_name: tabNameDe(indice),
        source: link.dataset.mmViewAllSource || 'card',
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-mm-panels]').forEach(initGrupo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
